import { BaseSortConvertor } from './base.sort.convertor';
import { RankTransformation } from 'app/model/dataflow/ranktransformation';
import { RankPlainObject } from 'worker/app-workers/shared/plainObjects/rank.plainObject';
import { Transformation } from 'app/model/dataflow/transformation';
import { SchemaConvertor } from './schema.convertor';
import { IResourceContext } from 'shell-models-lib';

export class RankConvertor extends BaseSortConvertor {
    private get rankTransform(): RankTransformation {
        return this.transformation as RankTransformation;
    }

    private get rankObject(): RankPlainObject {
        return this.transformObject as RankPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.rankTransform.keyColumn = SchemaConvertor.convertColumnFromPlainObject(
            this.rankObject.keyColumn,
            this.rankTransform
        );
        super.postConvert();
        return this.transformation;
    }
}
